import { Component, OnInit, TemplateRef } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../services/toaster.service';
import { CommonService } from '../services/common.service';
import { PlatformLocation } from '@angular/common';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-refer-article-detail',
  templateUrl: './refer-article-detail.component.html',
  styleUrls: ['./refer-article-detail.component.css'],
  providers: [ToasterService,CommonService]
})
export class ReferArticleDetailComponent implements OnInit {
  modalRef: BsModalRef;
  articleData: any;
  error: any;
  articleTitle: string;
  publishedDate: any;
  articleContent: any;
  articleId: any;
  loading: boolean;
  data : {};
  likeCount: string;
  sourceUrl: any;
  imageUrl: any;
  productId: any;
  cityList: any = [];
  noResult = false;
  article: boolean;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router, private serviceURLService: serviceURLService, private modalService: BsModalService, public toasterService: ToasterService, private platformLocation: PlatformLocation, public commonService : CommonService) {
    platformLocation.onPopState(() => {
      this.modalRef.hide();
    });
   }

  ngOnInit() {
    this.getArticlesData();
    this.getCities();
  }

  
  getArticlesData(){
    this.loading = true;
    
    var userId = localStorage.getItem("userID")
    this.serviceURLService.getArticlesData(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.article = true;
      this.articleData = successData.response;

      var url = window.location.pathname 
      var articleId = url.substr(url.lastIndexOf('/') + 1);
      for(var i=0; i<this.articleData.length; i++){
        
        if( articleId == this.articleData[i]._id){
          this.articleTitle = this.articleData[i].articleTitle;
          this.publishedDate = this.articleData[i].created;
          this.articleContent = this.articleData[i].articleContent;
          this.articleId = this.articleData[i]._id;
          this.likeCount = this.articleData[i].totalLikeCount;
          this.sourceUrl = this.articleData[i].articleSource;
          this.imageUrl = this.articleData[i].imageUrl;
          this.productId = this.articleData[i].linkedToproductType;
        }
      }
    }, errorData => {
      console.log("Oops..!! there is some error in downloading pdf", errorData);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  shareArticle(productId,f,articleId){
    this.loading = true;
    this.data = {
      "name":f.name,
      "email":f.email,
      "mobile":f.mobile,
      "productName":articleId,
      "ProductID":productId,
      "source":"Notify-Article",
      "city":f.location
    }
    var userId = localStorage.getItem("userID")
    this.serviceURLService.saveReferral(userId,this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.router.navigate(['refer-success']);
    }, errorData => {
      console.log("Oops..!! there is some error in downloading pdf", errorData);
      if (errorData.error.status === 403) {
        this.loading = false;
        this.error = errorData.error.message;
        this.toasterService.showErrorToaster(this.error);
      }else if (errorData.error.status === 400) {
        this.loading = false;
        this.toasterService.showErrorToaster("Please try another number.");
      }
    })
  }

  //call on like button click
  likeArticle(articleId){
    this.data = {
      "articleID":articleId
    }
    var userId = localStorage.getItem("userID")
    this.serviceURLService.sendLikeCount(this.data,userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log("Liked Successfully");
      this.likeCount = successData.response.likeCount;
      this.getArticlesData();
    }, errorData => {
      console.log("Oops..!! there is some error in downloading pdf", errorData);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
        this.toasterService.showErrorToaster(this.error);
      }else if (errorData.error.status === 400) {
        this.toasterService.showErrorToaster("You can give upto 50 likes.");
      }
    })
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false});
  }

  getCities() {
    this.loading = true;
    this.serviceURLService.getCities().pipe(takeUntil(this.onDestroy$)).subscribe(
        (success: any) => {
        this.loading = false;
        this.cityList = success.data.cityList;
        }, error => {
        this.loading = false;
        }
    )
  }

  selectCity(event: TypeaheadMatch): void {
    this.noResult = this.commonService.onSelectCity(event);
  }

  checkCityValue(event): void {
    this.noResult = this.commonService.checkCityValue(event,this.cityList);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
